<div>
  <mat-card-title class="u-mb--large">{{
    localizationConstants.SHIPPING_PACKAGES_REQUEST_FORM_TITLE | translate
  }}</mat-card-title>
  <div class="forms-wrapper">
    <div *ngFor="let packageForm of formArray?.controls; let i = index">
      <mat-card class="u-mat-elevation-0">
        <div class="package-form-header">
          <div class="flex u-align-center gap-sm u-color--dark-gray">
            {{ localizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_TITLE | translate }} {{ i + 1 }}
          </div>
          <div>
            <button
              data-testid="copy-package-btn"
              class="button button--sm button-secondary package-button u-color--dark-gray"
              (click)="copyPackage(packageForm.value)">
              <mat-icon svgIcon="copy"></mat-icon>
            </button>
            <button
              data-testid="remove-package-btn"
              class="button button--sm button-remove package-button u-color--dark-gray"
              (click)="removePackage(i)">
              <mat-icon svgIcon="trash-can"></mat-icon>
            </button>
          </div>
        </div>

        <mat-card-content>
          <form
            [formGroup]="packageForm"
            id="packages-form"
            class="packages-form flex">
            <div class="short-fields-wrapper col-md-6 col-12">
              <div class="package-form-input-wrapper">
                <label>{{
                  localizationConstants.SHIPPING_PACKAGES_REQUEST_FORM_DIMENSION_OPTIONS | translate
                }}</label>
                <mat-select
                  [formControlName]="formKeys.parcelType"
                  class="c-select c-select--md">
                  <mat-option
                    *ngFor="let optionType of parcelOptionsWithLabels | keyvalue: originalOrder"
                    [value]="optionType.key">
                    {{ optionType.value | translate }} ({{
                      getDimensionsLabel(optionType.key, customerSettings.unitOfMeasure)
                    }}
                    {{ lengthUnitTranslation | translate }})
                  </mat-option>
                </mat-select>
                <app-form-field-error
                  [control]="packageForm.get(formKeys.parcelType)"></app-form-field-error>
              </div>
              <div class="package-form-input-wrapper">
                <label
                  >{{ localizationConstants.SHIPPING_PACKAGES_REQUEST_FORM_WEIGHT | translate }} ({{
                    weightUnitTranslation | translate
                  }})</label
                >
                <input
                  min="1"
                  step="1"
                  type="number"
                  select-all-on-focus
                  class="c-input c-input--gamma"
                  [formControlName]="formKeys.weight" />
                <app-form-field-error
                  [control]="packageForm.controls[formKeys.weight]"></app-form-field-error>
              </div>
              <div class="package-form-input-wrapper">
                <label>{{
                  localizationConstants.SHIPPING_PACKAGES_REQUEST_FORM_DESCRIPTION | translate
                }}</label>
                <input
                  type="text"
                  class="c-input c-input--gamma"
                  [formControlName]="formKeys.description" />
                <app-form-field-error
                  [control]="packageForm.controls[formKeys.description]"></app-form-field-error>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <app-shipping-package-graphic
                *ngIf="parcelDimensionOptions && customerSettings"
                [customerSettings]="customerSettings"
                [length]="parcelDimensionOptions[packageForm.value.parcelType]?.length"
                [width]="parcelDimensionOptions[packageForm.value.parcelType]?.width"
                [height]="parcelDimensionOptions[packageForm.value.parcelType]?.height">
              </app-shipping-package-graphic>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="flex u-mb--large gap-lg u-align-center">
    <button
      data-testid="add-package-btn"
      class="button button--sm button-secondary flex u-align-center gap-sm"
      (click)="addPackage()">
      <mat-icon svgIcon="add-parcel"></mat-icon>
      {{ localizationConstants.SHIPPING_PACKAGES_ADD_PACKAGE | translate }}
    </button>
  </div>
</div>
